// extracted by mini-css-extract-plugin
export default {"Main":"main_Main__nKlhg","textSide":"main_textSide__Q9MQr","footerLinks":"main_footerLinks__ko157"};